import Select from 'react-select';
import styled from 'styled-components';
import { ModeOption } from './index';

export const StyledSelect = styled(Select<ModeOption>)`

&.custom-react-select-mode{
	.cus-select__control{
		border-color: var(--inputBorderColor);;
		min-height: 38px;
		height: 38px;
    align-items: flex-start;
		font-size: 13px;
		border-radius: 8px;
		background-color: var(--selectDropdownBgColor);
	}
	.cus-select__value-container{
		padding: 10px 10px !important;	
		line-height: 16px;
	}
	.cus-select__indicator-separator{
		margin-top: 0px !important;
		margin-bottom: 0px !important;
		background-color: var(--inputBorderColor);
	}
	.cus-select__dropdown-indicator{
    color: #595A5A;
		padding: 7px 9px;

		svg{
			height: 20px;
			width: 20px;
			fill: #b0b2b4;
		}
  }
	
	.cus-select__single-value{
	  // color: #2E384D;
		color: var(--textColor);
		padding-right: 1.6rem;
	}
	&.cus-select--is-disabled{
		cursor: not-allowed !important;
		opacity: .6 !important;
		pointer-events: auto !important;

		* {
			cursor: not-allowed !important;
		}
	}
}
 
	width: 100%;
	// max-width: 350px;
	font-size: .9rem;
	margin-top: 0px;
	color: var(--textColor);

	.custom-react-select-mode{
			.cus-select__value-container{
				padding: 8px 8px;
				.cus-select__single-value{
					line-height: 1.4;
				}
			}
	}
  
	.react-select__menu-list {
    max-height: 100px;
    width: 100%;
  }
		.cus-select__menu{
			margin-top: 2px;
			overflow: hidden;
			background-color: var(--selectDropdownBgColor);

			.cus-select__menu-list{
				padding-top:0;
				padding-bottom:0;
				font-size: 13px;
			}
		}

`;

export const SelectorDiv = styled.div`
 
	width: 100%;
	// max-width: 250px;

	display: flex;
	flex-direction: column;
	justify-content:space-between;
	align-items:flex-start;
	gap: 0px;
	color: var(--textColor);
	font-weight: 500;
	font-size: 0.95rem;
	margin-right: 0px;
	margin-bottom: 10px;
	white-space: nowrap;
	font-family: 'Inter';
	
	label{
		color: var(--textColor);
		font-family: 'Inter';
		font-size: 15px;
		font-weight: 500;
		margin-bottom:3px;
	}
		&.fullScreenSelector{
			.custom-react-select-mode{
				font-size: .8125rem;
			}
		}
`;

export const DivSolarImagery = styled.div`

`; 
export const DivLabel = styled.div`

`;
export const DivValue = styled.div`

`;
export const DivWrap = styled.div`

`;
export const IconPremium = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
		background-color: #FFF0CF;
		color: var(--textColor) !important;
		border: 1px solid var(--secondary);
		border-radius: 15px;
		font-weight: 500 !important;
		padding: 4px 8px;
		font-size: 11px !important;
		marginLeft: 2px;
		lineHeight: 1.4;
		svg{
			position: relative;
    	top: -1px;
		}
`;